import { StringParam } from 'use-query-params'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import { MANAGING_MONITORING_PRICING_LEVEL, MANAGING_MONITORING_PRICING_LEVEL_TITLE } from '@app/api/constants'

import { LntSelectOption } from '@app/components/base/Select/types'

import type { ManagingMonitoringsColumn, ManagingMonitoringsDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'

export const columnTitleMap: Record<keyof ManagingMonitoringsColumn, string> = {
  monitoringType: 'Тип мониторинга',
  monitoringKind: 'Вид мониторинга',
  pricingLevel: 'Уровень расценки',
  isActive: 'Активен'
}

export const tableSearchQuerySchema: TableSearchQuerySchema<ManagingMonitoringsDataSource> = {
  'table-monitoringType': StringParam,
  'table-monitoringKind': StringParam,
  'table-pricingLevel': StringParam
} as const

export const pricingLevelOptions = Object.values(MANAGING_MONITORING_PRICING_LEVEL).map<LntSelectOption>(
  pricingLevel => {
    return {
      label: MANAGING_MONITORING_PRICING_LEVEL_TITLE[pricingLevel],
      value: MANAGING_MONITORING_PRICING_LEVEL_TITLE[pricingLevel]
    }
  }
)

export const columnsSearchSchema: ColumnTableSearchSchema<ManagingMonitoringsDataSource> = {
  monitoringType: { type: columnSearchSchemaOptionType.INPUT },
  monitoringKind: { type: columnSearchSchemaOptionType.INPUT },
  pricingLevel: { type: columnSearchSchemaOptionType.SELECT, controlProps: { options: pricingLevelOptions } }
}
